import React from 'react';
import PropTypes from 'prop-types';
import { CallForSpeakersProvider } from './CallForSpeakersContext';
import { SpeakersProvider } from './SpeakersContext';
import { SpeakerDetailsProvider } from './SpeakerDetailsContext';
import { ProgramProvider } from './ProgramContext';
import { TalkDetailsProvider } from './TalkDetailsContext';

const ContextProviders = props => {
  const { children } = props;
  return (
    <CallForSpeakersProvider>
      <SpeakersProvider>
        <SpeakerDetailsProvider>
          <TalkDetailsProvider>
            <ProgramProvider>{children}</ProgramProvider>
          </TalkDetailsProvider>
        </SpeakerDetailsProvider>
      </SpeakersProvider>
    </CallForSpeakersProvider>
  );
};

ContextProviders.propTypes = {
  children: PropTypes.node.isRequired
};

export default ContextProviders;
